import React from 'react';
import PropTypes from 'prop-types';
import DashboardCard from './DashboardCard';
import i18n from '../i18n/translate';
import orderBy from 'lodash/orderBy';

const TodoCard = ({ emptyStateImage, onDismiss, todos = [] }) => {

  const getCardSpecs = todo => {
    switch(todo.type) {
    case 'Todo::EmailBounceListUpdated':
      return { 
        titleIcon: 'email',
        title: i18n.t('Bouncing Emails'),
        buttonConfig: [{
          label: i18n.t('View Bounce List'),
          style: 'link',
          action: () => { window.location.href = todo.action_link },
          data: { action: 'action-dash-view-email-list', objectType: 'todo_item', objectId: todo.id }
        }]
      };
    case 'Todo::ReassignmentIssue': 
      return { 
        titleIcon: 'info',
        title: i18n.t('Reassignment Issue'),
        buttonConfig: [{
          label: i18n.t('View Assignment'),
          style: 'link',
          action: () => { window.location.href = todo.action_link },
          data: { action: 'action-dash-view-reassignment', objectType: 'todo_item', objectId: todo.id }
        }] 
      };
    case 'Todo::UserRegistrationBatchFailed':
      return { 
        titleIcon: 'accounts',
        title: i18n.t('User Upload Failed'),
        buttonConfig: [{
          label: i18n.t('Download Error List'),
          style: 'link',
          action: () => { window.location.href = todo.action_link },
          data: { action: 'action-dash-download-error', objectType: 'todo_item', objectId: todo.id }
        }] 
      };
    case 'Todo::AssignmentDueSoon':
      return { 
        titleIcon: 'assignment-alert',
        title: i18n.t('Upcoming Due Date'),
        buttonConfig: [{ 
          label: i18n.t('View Assignment'),
          style: 'link',
          action: () => { window.location.href = todo.action_link },
          data: { action: 'action-dash-upcoming-due-date', objectType: 'todo_item', objectId: todo.id }
        }] 
      };
    default:
      break;
    }
  }

  const getEmptyComponent = () => (
    <>
      <img src={emptyStateImage} />
      <div>{i18n.t("You currently have no action items.")}</div>
      <div>{i18n.t("Good job!")}</div>
    </>
  );

  const orderedTodos = orderBy(todos, ['created_at'], ['desc']);

  return (
    <DashboardCard 
      type="todo"
      title={i18n.t('To Do')}
      items={orderedTodos} 
      emptyComponent={getEmptyComponent()}
      getItemCardProps={todo => ({
        description: todo.message,
        dismissable: true,
        onDismiss: () => onDismiss(todo.id),
        ...getCardSpecs(todo)
      })}
    />
  );
}

TodoCard.propTypes = {
  emptyStateImage: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  todos: PropTypes.array
};

export default TodoCard;
